import request from "@/utils/request";

// 获取任务分页列表
export function getTaskPageList(data) {
  return request({
    url: "/task/page",
    method: "post",
    data: data
  });
}

export function addTask(task) {
  return request({
    url: "/task/add",
    method: "post",
    data: task
  });
}

export function getTaskDetail(taskId) {
  return request({
    url: "/task/info?taskId=" + taskId,
    method: "get"
  });
}

// 获取车辆当前任务
export function getCurrentTaskByVehcileId(taskId) {
  return request({
    url: "/task/current?vehicleId=" + taskId,
    method: "get"
  });
}

export function updateTask(task) {
  return request({
    url: "/task/update",
    method: "post",
    data: task
  });
}

// 任务审核（通过/驳回）
export function reviewTask(data) {
  return request({
    url: "/task/approve",
    method: "post",
    data: data
  });
}


